module.exports = __webpack_public_path__ + "img/customReport.6bcd396b.svg";